import { useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import FolderIcon from '@material-ui/icons/Folder'
import FolderSharedIcon from '@material-ui/icons/FolderShared'
import TheatersIcon from '@material-ui/icons/Theaters'

import msgraph from 'modules/msgraph'

const useStyles = makeStyles({
    thumbnailContainer: {
        width: '3rem',
        height: '3rem',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    thumbnail: {
        maxWidth: '100%',
        maxHeight: '100%'
    },
    thumbnailIcon: {
        width: '44px',
        height: '44px',
        fill: '#b9d1fd'
    }
})

export const ItemThumbnail = ({ file }) => {
    const [couldNotFetchImg, setError] = useState(false)
    const { thumbnailContainer, thumbnail, thumbnailIcon } = useStyles()

    return (
        <div className={thumbnailContainer}>
            {file.kind === 'drive#drive' &&
                (file.id === 'root' ? (
                    <FolderIcon className={thumbnailIcon} />
                ) : (
                    <FolderSharedIcon className={thumbnailIcon} />
                ))}

            {!file.mimeType && file.kind !== 'drive#drive' && (
                <TheatersIcon className={thumbnailIcon} />
            )}

            {file.mimeType === 'application/vnd.google-apps.folder' && (
                <FolderIcon className={thumbnailIcon} />
            )}

            {(file.mimeType === 'video/mp4' || file.mimeType === 'video/quicktime') &&
                (file.hasThumbnail && !couldNotFetchImg ? (
                    <img
                        alt=""
                        src={file.thumbnailLink}
                        className={thumbnail}
                        onError={() => setError(true)}
                    />
                ) : (
                    <TheatersIcon className={thumbnailIcon} />
                ))}
        </div>
    )
}

export const OneDriveItemThumbnail = ({ file }) => {
    const { thumbnailContainer, thumbnailIcon } = useStyles()

    return (
        <div className={thumbnailContainer}>
            {msgraph.isFolder(file) ? (
                <FolderIcon className={thumbnailIcon} />
            ) : (
                <TheatersIcon className={thumbnailIcon} />
            )}
        </div>
    )
}
